module.exports = __webpack_public_path__ + "static/media/modal_close.74f8cb64.svg";